import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SidebarLink from './SidebarLink';
// import SidebarCategory from './SidebarCategory';

class SidebarContent extends Component {
  static propTypes = {
    // changeToDark: PropTypes.func.isRequired,
    // changeToLight: PropTypes.func.isRequired,
    onClick: PropTypes.func.isRequired,
    accesses_received: PropTypes.arrayOf(PropTypes.shape({}).isRequired).isRequired,
  };

  hideSidebar = () => {
    const { onClick } = this.props;
    onClick();
  };

  render() {
    const { accesses_received } = this.props;
    return (
      <div className="sidebar__content">
        <SidebarLink title="Accueil" icon="home" route="/dashboard" onClick={this.hideSidebar} />
        {
          accesses_received && accesses_received.length > 0 && (
            <ul className="sidebar__block">
              <SidebarLink title="Accès reçus" image="access_shared" route="/trusted-for" onClick={this.hideSidebar} />
            </ul>
          )
        }
        <ul className="sidebar__block">
          <a href="https://help.legitbee.com" target="_blank" rel="noopener noreferrer">
            <li className="sidebar__link">
              <span className="sidebar__link-icon lnr lnr-question-circle" />
              <p className="false sidebar__link-title">FAQ</p>
            </li>
          </a>
        </ul>
      </div>
    );
  }
}

export default connect(state => ({
  accesses_received: state.accesses_received,
}))(SidebarContent);
